module.exports = __webpack_public_path__ + "static/img/news-logo.d475671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-logo.png
// module id = EhHi
// module chunks = 1